module.exports = __webpack_public_path__ + "static/media/image_new1.a24bbe94.png";